import { controls } from './formParts/AccrualPeriodFormCompensation'


export const checkErrorsCompensationAccrualPeriod = (err: Map<string, string>, formData: FormData) => {
  if (!(
    formData.get(controls.accrualPeriod)
  )) {
    err.set(controls.accrualPeriod, 'Выберите хотя бы один пункт')
  }
}
